import { cn } from '../../lib/cn';
import type { CatalogEntryRow } from '../../enterpriseintegration/framework';

type Props = { entries?: CatalogEntryRow[] };

export function EventCatalogPanel({ entries = [] }: Props) {
  return (
    <div className="space-y-2">
      {entries.map((e) => (
        <div key={e.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{e.name}</p>
            <p className="text-xs text-slate-500">{e.count.toLocaleString()} registered</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            e.status === 'active' || e.status === 'validated' || e.status === 'enforced' || e.status === 'registered' || e.status === 'governed'
              ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
              : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
          )}>
            {e.status}
          </span>
        </div>
      ))}
    </div>
  );
}
